import {
    Component, ViewEncapsulation, OnInit, AfterViewInit, EventEmitter, Output, forwardRef,
    Input
} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

declare var Dropzone;

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UploadOneFileComponent),
    multi: true
};

@Component({
    selector: 'uploadfile',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    encapsulation: ViewEncapsulation.None
})
export class UploadOneFileComponent implements AfterViewInit, ControlValueAccessor{

    _dropzone:any;

    files: any;

    @Input() startUpload : EventEmitter<any>;
    @Input() url:string;

    @Output() uploadFinished = new EventEmitter<string>();
    @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();

    onTouched = () => {};

    ngAfterViewInit(): void {
        DropzoneDefaultSettings.url = this.url;
        this._dropzone = new Dropzone("#firmware-uploader", DropzoneDefaultSettings);

        this._dropzone.on('addedfile', (file) => this._actualizeFileList(file) );
        this._dropzone.on('success', (file) => this._uploadFinished(event) );

        this.startUpload.subscribe(() => this.upload());
    }

    upload(): void {
        this._dropzone.processQueue();
    }

    _actualizeFileList(file){
        this.files = file;
        this.onChangeEvent.emit(file.name);
    }

    _uploadFinished(event){
        let result_json = JSON.parse(event.currentTarget.response);

        this.uploadFinished.emit(result_json.message);
    }

    writeValue(initial_value: any): void {
        this.files = initial_value;
    }

    registerOnChange(fn: any): void {
        this.onChangeEvent.subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}

const DropzoneDefaultSettings = {
    url: '',
    maxFilesize: 1024,
    autoProcessQueue: false,
    uploadMultiple: false,
    maxFiles: 1
};


// WEBPACK FOOTER //
// ./src/app/front/upload/upload-file/upload-file.component.ts